import { bind } from 'decko'
import { LiveElement, LiveNodeList } from 'live-node-list'

export default class PredictiveSearch {

  /**
   * @type {LiveNodeList}
   */
  searchInput = new LiveNodeList('.search-form-input')

  /**
   * @type {LiveNodeList}
   */
  searchClose = new LiveNodeList('.predictive-search__close')

  constructor() {
    this.registerListeners()
  }

  @bind
  registerListeners() {
    if (!this.searchInput) {
      return
    }

    this.searchInput.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.searchClose.addEventListener('click', (event) => {
      event.preventDefault()
      const resultsBox = event.target.closest('.predictive-search-results')
      this.close(resultsBox);
    });
  }

  @bind
  onChange(event) {
    const searchTerm = event.target.value.trim();
    const resultsBox = event.target.closest('.search-form').querySelector('.predictive-search-results')

    if (!searchTerm.length) {
      this.close(resultsBox);
      return;
    }

    this.getSearchResults(searchTerm, resultsBox);
  }

  @bind
  getSearchResults(searchTerm, resultsBox) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close(resultsBox);
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        resultsBox.innerHTML = resultsMarkup;
        this.open(resultsBox);
      })
      .catch((error) => {
        this.close(resultsBox);
        throw error;
      });
  }

  @bind
  open(resultsBox) {
    resultsBox.classList.remove('hide')
  }

  @bind
  close(resultsBox) {
    resultsBox.classList.add('hide')
  }

  @bind
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
